import { env } from "@/env";

export type StreamMode = "live" | "mock" | "record";

const FALLBACK_MODE: StreamMode = "live";

const rawMode = env.VITE_AGENT_STREAM_MODE;
const resolvedMode: StreamMode =
	rawMode === "mock" || rawMode === "record" ? rawMode : FALLBACK_MODE;

if (import.meta.env.DEV) {
	console.info(`[agent-stream] mode: ${resolvedMode}`);
}

export const streamMode: StreamMode = resolvedMode;
export const isMockMode = streamMode === "mock";
export const isRecordMode = streamMode === "record";
export const isLiveMode = streamMode === "live";
